import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useParams, useNavigate} from 'react-router-dom';
import {Box, CircularProgress} from '@mui/material';
import {
  CustomersTab,
  Layout,
  PageHeader,
  TabsContainer,
} from '../../components';
import {
  getBuildingById,
  getCustomersByBuilding,
  getElevatorsByBuilding,
  getEntrancesByBuilding,
  getGaragesByBuilding,
  openModal,
} from '../../actions';
import CustomersTable from '../../components/CustomTables/CustomersTable';
import EntrancesTab from './EntrancesTab';
import ElevatorsTab from './ElevatorsTab';
import GaragesTab from './GaragesTab';

const HEADERS = ['Entrances', 'Elevators', 'Customers', 'Garages'];

const ComplexDetails = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const {id} = params;
  const [loading, setLoading] = useState(true);
  const {buildingById} = useSelector(s => s.buildings);
  const {user} = useSelector(s => s.user);
  const {buildingCustomers, customersLoading} = useSelector(s => s.customers);

  const onBack = () => {
    navigate(-1);
  };

  const onEdit = () => {
    dispatch(openModal('EditComplexModal', buildingById));
  };

  const onDelete = () => {
    dispatch(openModal('DeleteModal', {item: buildingById, type: 'complex'}));
  };

  const EntrancesTable = <EntrancesTab />;
  const ElevatorsTable = <ElevatorsTab />;
  const CustomersTable = <CustomersTab building />;
  const GaragesTable = <GaragesTab />;

  const TAB_CONTENTS = [
    EntrancesTable,
    ElevatorsTable,
    CustomersTable,
    GaragesTable,
  ];

  useEffect(() => {
    dispatch(getBuildingById(id));
    dispatch(getEntrancesByBuilding(id));
    dispatch(getElevatorsByBuilding(id));
    dispatch(getCustomersByBuilding(id));
    dispatch(getGaragesByBuilding(id));
  }, []);

  useEffect(() => {
    if (loading) {
      if (buildingById && buildingById.id.toString() === id) {
        setLoading(false);
      }
    }
  }, [buildingById]);

  if (loading) {
    return (
      <Layout>
        <Box
          display="flex"
          flex={1}
          justifyContent="center"
          alignItems="center">
          <CircularProgress />
        </Box>
      </Layout>
    );
  }

  return (
    <Layout>
      <PageHeader
        title={buildingById?.name}
        onBack={onBack}
        onEdit={onEdit}
        onDelete={!!user?.role && user?.role === 'SUPERADMIN' && onDelete}
      />
      <TabsContainer tabHeaders={HEADERS} tabContents={TAB_CONTENTS} />
    </Layout>
  );
};

export default ComplexDetails;
